import { cn } from "@/lib/utils";
import { Typography } from "@/components/ui/typography";

interface ThreeBodyLoaderProps {
  className?: string;
  label?: string;
}

/**
 * Three-body spinner (Uiverse tidy-walrus-92) with brand teal dots.
 */
export function ThreeBodyLoader({
  className,
  label = "در حال بروزرسانی قیمت...",
}: ThreeBodyLoaderProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-4 py-10",
        className,
      )}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={label}
    >
      <div className="three-body" aria-hidden="true">
        <div className="three-body__dot" />
        <div className="three-body__dot" />
        <div className="three-body__dot" />
      </div>
      {label ? (
        <Typography
          variant="bodySRegular"
          color="gray500"
          className="text-center"
          aria-hidden="true"
        >
          {label}
        </Typography>
      ) : null}
    </div>
  );
}
